var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "main-nav-container",
      attrs: { id: "page-header", role: "banner" }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "content-container", attrs: { id: "headercontent" } },
          [
            _vm.isInPrintMode
              ? _c(
                  "div",
                  { staticClass: "logocontainer" },
                  [_c("stea-logo")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isInPrintMode && _vm.currentUser
              ? _c("div", [
                  _c("div", { staticClass: "d-block d-lg-none mobile" }, [
                    _c("div", { staticClass: "row justify-content-between" }, [
                      _c(
                        "div",
                        { staticClass: "col-10" },
                        [_c("organisation"), _vm._v(" "), _c("user")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [_c("language-selection")],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("main-nav", {
                            attrs: { id: "mobileNav" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "logo",
                                  fn: function() {
                                    return [
                                      _c("stea-logo-link", {
                                        staticClass: "small"
                                      })
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "link1",
                                  fn: function() {
                                    return [
                                      _c("organisation-information-link", {
                                        attrs: {
                                          classes: "nav-link",
                                          hideChevron: true
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "link2",
                                  fn: function() {
                                    return [
                                      _vm.currentUser.isAdmin
                                        ? _c("user-management-link", {
                                            attrs: {
                                              hideChevron: true,
                                              classes: "nav-link"
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "link3",
                                  fn: function() {
                                    return [_c("logout")]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              2189544201
                            )
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-none d-lg-block d-xl-none" }, [
                    _c("div", { staticClass: "row justify-content-between" }, [
                      _c(
                        "div",
                        { staticClass: "col-5" },
                        [_c("organisation")],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-5" }, [_c("user")], 1),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [_c("language-selection")],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [_c("stea-logo-link", { staticClass: "small" })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-9 right" },
                        [
                          _c("organisation-information-link"),
                          _vm._v(" "),
                          _vm.currentUser.isAdmin
                            ? _c("user-management-link")
                            : _vm._e(),
                          _vm._v(" "),
                          _c("logout")
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [_c("main-nav", { attrs: { id: "lgNav" } })],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-none d-xl-block" }, [
                    _c("div", { staticClass: "row justify-content-between" }, [
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [_c("organisation"), _vm._v(" "), _c("user")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-1" },
                        [_c("language-selection")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-7 right control-links" },
                        [
                          _c("organisation-information-link"),
                          _vm._v(" "),
                          _vm.currentUser.isAdmin
                            ? _c("user-management-link")
                            : _vm._e(),
                          _vm._v(" "),
                          _c("logout")
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("main-nav", {
                            attrs: { id: "fullNav" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "logo",
                                  fn: function() {
                                    return [_c("stea-logo-link")]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              3612906859
                            )
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }